import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import * as d3 from 'd3';
import { useEffect, useRef } from 'react';
import { useChartData } from '../context/ChartContext';
import { useScale } from '../context/ScaleContext';
const axisStyles = css `
  user-select: none;

  path,
  line {
    fill: none;
    stroke: black;
    stroke-width: 1;
    shape-rendering: crispedges;
    user-select: none;
  }
`;
const gridStyles = css `
  user-select: none;

  line {
    stroke: rgb(104 104 104);
    stroke-opacity: 0.2;
    shape-rendering: crispedges;
    stroke-dasharray: 3;
    stroke-width: 1;
    user-select: none;
  }

  path {
    stroke-width: 0;
  }
`;
function XAxis(props) {
    const { show = true, showGrid = false, mode, label: labelProp } = props;
    const { xDomain, height, width, margin } = useChartData();
    const { scaleX } = useScale();
    const refAxis = useRef(null);
    const refGrid = useRef(null);
    const label = labelProp || (mode === 'RTL' ? 'δ [ppm]' : 'time [s]');
    useEffect(() => {
        if (!show || !scaleX)
            return;
        const xAxis = d3
            .axisBottom(scaleX().domain(xDomain))
            .ticks(8)
            .tickFormat(d3.format('0'));
        const grid = d3
            .axisBottom(scaleX().domain(xDomain))
            .ticks(50)
            .tickSize(-(height - margin.top - margin.bottom))
            .tickFormat(() => '');
        // @ts-expect-error This line of code is actually well typed ...
        d3.select(refAxis.current).call(xAxis);
        // @ts-expect-error ditto
        d3.select(refGrid.current).call(grid);
    }, [height, margin.bottom, margin.top, scaleX, show, xDomain]);
    if (!width || !height || !scaleX) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [show && (_jsx("g", { className: "x", css: axisStyles, transform: `translate(0,${height - margin.bottom})`, ref: refAxis, children: _jsx("text", { fill: "#000", x: width - 10, y: "30", dy: "0.70em", textAnchor: "end", children: label }) })), showGrid && (_jsx("g", { "data-no-export": "true", css: gridStyles, className: "grid", ref: refGrid, transform: `translate(0,${height - margin.bottom})` }))] }));
}
export default XAxis;
